import toMap from "~/misc/toMap";

export default toMap([
  "BOOKING_GET",
  "BOOKING_CREATE",
  "BOOKING_CANCEL",
  "BOOKING_DELETE",
  "BOOKING_CREATE_DYNAMIC",
]);



// WEBPACK FOOTER //
// ./src/modules/bookings/types.js